import { atom } from "jotai";
import { loadable } from "jotai/utils";
import { komodoApi } from "../service/komodoApi";
const komodoConnectionAsyncAtom = atom(() => komodoApi.getConnection());
/** Fetched once and shared app-wide; read via useAtomValue for a Loadable ({state, data|error}). */
export const komodoConnectionAtom = loadable(komodoConnectionAsyncAtom);
